export const truncateText = (text: string, first: number, last: number) =>
  text.slice(0, first) + '...' + text.slice(text.length - last, text.length)
